import type { OnInit } from '@angular/core'
import { Component, DOCUMENT, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { TranslateService } from '@ngx-translate/core'

import { FooterComponent } from './components/footer/footer.component'
import { NavigationHeaderComponent } from './components/navigation-header/navigation-header.component'
import { SiteBannerComponent } from './components/site-banner/site-banner.component'
import { UnpaidSubscriptionBannerComponent } from './components/unpaid-subscription-banner/unpaid-subscription-banner.component'
import { WelcomeDialogComponent } from './components/welcome-dialog/welcome-dialog.component'
import { AuthService } from './services/auth/auth.service'

@Component({
  selector: 'dhp-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, WelcomeDialogComponent],
})
export class AppComponent implements OnInit {
  private document = inject<Document>(DOCUMENT)
  private translateService = inject(TranslateService)
  readonly authService = inject(AuthService)

  currentLanguage = 'en'

  ngOnInit(): void {
    if (this.authService.authCheckCompleted()) {
      this.hideBootstrapLoader()
    }

    this.document.documentElement.lang =
      this.translateService.getCurrentLang() ?? this.currentLanguage

    this.translateService.onLangChange.subscribe(event => {
      this.currentLanguage = event.lang
      // This should be a BCP 47 language tag
      this.document.documentElement.lang = event.lang
    })
  }

  private hideBootstrapLoader(): void {
    const removeLoader = () => {
      this.document.getElementById('app-bootstrap-loader')?.remove()
    }

    const defaultView = this.document.defaultView

    if (defaultView?.requestAnimationFrame) {
      const requestAnimationFrame =
        defaultView.requestAnimationFrame.bind(defaultView)

      requestAnimationFrame(removeLoader)
      return
    }
  }
}

@Component({
  template: `
    <div class="flex min-h-screen flex-col">
      <dhp-site-banner></dhp-site-banner>
      <dhp-unpaid-subscription-banner></dhp-unpaid-subscription-banner>
      <!-- Navigation Header -->
      <dhp-navigation-header class="print:hidden"></dhp-navigation-header>
      <!-- Router Outlet -->
      <div class="flex-1">
        <router-outlet></router-outlet>
      </div>
      <!-- Footer -->
      <dhp-footer class="print:hidden"></dhp-footer>
    </div>
  `,
  imports: [
    SiteBannerComponent,
    UnpaidSubscriptionBannerComponent,
    NavigationHeaderComponent,
    RouterOutlet,
    FooterComponent,
  ],
})
export class MainLayoutComponent {}

@Component({
  template: ` <router-outlet></router-outlet> `,
  imports: [RouterOutlet],
})
export class AuthLayoutComponent {}
